@for (item of items; track $index; let index = $index) {
  @if (item.dividerBefore) {
    <div class="m-0 border-t border-grey-concrete/70"></div>
  }
  <div
    [id]="item.id ? item.id : index"
    class="p-2 rounded flex items-center cursor-pointer"
    [ngClass]="{
      '!text-bright-crimson hover:!bg-bright-crimson/10': item.destructive,
      'hover:bg-turquoise-bright/20 text-grey-blue hover:text-turquoise-mid': !item.destructive,
    }"
    (click)="selectItem(item)"
  >
    @if (item.iconName && item.iconPosition !== 'end') {
      <ion-icon class="h-5 w-5 {{ item.iconClass }}" [name]="item.iconName"></ion-icon>
    }
    <div class="ml-2 font-medium flex-1" [ngClass]="{ '!text-bright-crimson': item.destructive }">
      <span>{{ item.title }}</span>
      <div class="text-xxs font-normal" [ngClass]="{ '!text-bright-crimson/80': item.destructive }">
        {{ item.subtitle }}
      </div>
    </div>
    @if (item.iconName && item.iconPosition === 'end') {
      <ion-icon class="h-5 w-5 ml-2 {{ item.iconClass }}" [name]="item.iconName"></ion-icon>
    }
  </div>
}
